import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { ButtonComponent } from '../button/button.component';
import { LabelComponent } from '../label/label.component';
import { Types } from 'shared-lib';
import { EComponentSize, EIcon, ELabelType } from '../../types';
import { helper } from '../../../public-api';

@Component({
  selector: 'ui-image-uploader',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent, LabelComponent],
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss']
})
export class ImageUploaderComponent {
    @Input() title = '';
    @Output() imagesUploaded = new EventEmitter<File[]>();
  
    darkMode: boolean = false;
    files: Array<{ file: File, preview: string }> = [];
    isDragOver: boolean = false;
    isHovering: boolean = false;

    EAlert = Types.EAlert;
    EIcon = EIcon;
    EComponentSize = EComponentSize;
    ELabelType = ELabelType;
  
    constructor() {
      this.darkMode = helper.Functions.isDarkMode();
    }
  
    ngOnInit() {
      this.darkMode = helper.Functions.isDarkMode();
    }
  
    triggerFileInput(): void {
      document.getElementById('fileInput')?.click();
    }
  
    handleFileChange(event: any): void {
      const selectedFiles: File[] = Array.from(event.target.files);
      selectedFiles.forEach((file: File) => {
        this.files.push({
          file,
          preview: URL.createObjectURL(file),
        });
      });
    }
  
    handleDrop(event: any): void {
      event.preventDefault();
      const droppedFiles: File[] = Array.from(event.dataTransfer.files);
      droppedFiles.forEach((file: File) => {
        this.files.push({
          file,
          preview: URL.createObjectURL(file),
        });
      });
      this.isDragOver = false;
    }
  
    dragOver(event: any): void {
      event.preventDefault();
      this.isDragOver = true;
    }
  
    removeImage(index: number): void {
      this.files.splice(index, 1);
    }
  
    confirmImages(): void {
      const imageFiles: File[] = this.files.map((file) => file.file);
      this.imagesUploaded.emit(imageFiles);
      this.files = [];
    }
  }